module.exports = __webpack_public_path__ + "img/Editor.a2eac574.png";